module.exports = __webpack_public_path__ + "img/jianzhu.6e754943.png";